import { PaletteMode } from '@mui/material';
import icons from './icons';
import dimensions from './dimensions';
import { themePalette } from './theme.palette';
import { themeShadows } from './theme.shadows';
import { typographyTokens } from './typography-tokens';
import type { ComponentTokens } from './component-tokens';

declare module '@mui/material/styles' {
  interface Theme {
    dimensions: typeof dimensions;
    pounce: {
      icons: typeof icons;
      typographyTokens: typeof typographyTokens;
      componentTokens: ComponentTokens;
    };
  }

  interface ThemeOptions {
    dimensions?: typeof dimensions;
    pounce?: {
      icons?: typeof icons;
      typographyTokens?: typeof typographyTokens;
      componentTokens?: ComponentTokens;
    };
  }
}

export const themeBase = (mode: PaletteMode) => ({
  dimensions,
  pounce: {
    icons,
    typographyTokens,
    componentTokens: themePalette(mode).componentTokens,
  },
  palette: themePalette(mode),
  shadows: themeShadows(mode),
  typography: {
    fontFamily: typographyTokens.fontFamilies.sans,
  },
  breakpoints: {
    values: {
      xs: parseInt(dimensions.breakpointXs, 10),
      sm: parseInt(dimensions.breakpointSm, 10),
      md: parseInt(dimensions.breakpointMd, 10),
      lg: parseInt(dimensions.breakpointLg, 10),
      xl: parseInt(dimensions.breakpointXl, 10),
    },
  },
  spacing: dimensions.spacing,
  shape: {
    borderRadius: parseInt(dimensions.borderRadius, 10),
  },
});
